// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"fd6ac775","977":"c8e4887d"}[chunkId] + ".chunk.js";
};